export default __webpack_public_path__ + "assets/jordan-flag.png";